// src/components/Header.js

import React from 'react';
import { Link } from 'react-router-dom';
import { useDoorloopjes } from '../context/DoorloopjesContext'; 

const Header = ({ onLoginClick, onRegisterClick }) => {
  const { globalSettings, loading } = useDoorloopjes(); 

  const dynamicLogoUrl = globalSettings?.logo?.url || '/logo192.png';
  const siteTitle = globalSettings?.siteTitle || 'Doorloopjes'; 

  const poweredByLogoUrl = globalSettings?.poweredByLogo?.url;

  if (loading && !globalSettings) {
    return (
      <header className="main-header">
        <div className="header-content">
          <div
            className="logo"
            style={{
              width: '35px',
              height: '35px',
              backgroundColor: 'lightgray',
              borderRadius: '50px',
              marginLeft: '1rem'
            }}
          />
          <div className="header-actions">
            <button className="btn-secondary" disabled>Inloggen</button>
            <button className="btn-primary" disabled>Registreren</button>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="main-header">
      <div className="header-content">
        {/* Logo + Powered-by rechts daarvan */}
        <div className="header-logo-block">
          <Link to="/" className="logo-link" aria-label={`${siteTitle}, naar de homepage`}>
            <img src={dynamicLogoUrl} alt="" className="logo" />
          </Link>
          <div className="powered-by-inline" aria-label="Powered by">
            <span>
              Powered by Stichting leer<strong>kracht</strong>
            </span>
            {poweredByLogoUrl && (
              <a
                href="https://stichting-leerkracht.nl/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Stichting leerkracht (opent in een nieuw tabblad)"
                title="Stichting leerkracht"
              >
                <img src={poweredByLogoUrl} alt="Stichting leerkracht" />
              </a>
            )}
          </div>
        </div>

        <div className="header-actions">
          <button onClick={() => onLoginClick()} className="btn-secondary">Inloggen</button>
          <button onClick={onRegisterClick} className="btn-primary">Registreren</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
